var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.areProConditionsUsedInRules)?_c('ProOnlyAlertBox',{staticClass:"mb-5",attrs:{"options":{
    feature: 'conditions',
    content: `Get ${_vm.$bdox(
      'plugin_name'
    )} Pro to get access to all the conditions.`
  }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }